import "./iconlegend.scss";
import IconLegendModal from "../IconLengendModal/IconLegendModal";

const IconLegend = ({showIconLegendModal, setShowIconLegendModal}) => {
  return (
    <div className="icon-legend-wrapper">
      <div className={`icon-legend ${showIconLegendModal? 'bg-[#023E65]' : 'bg-white'}`} onClick={() => setShowIconLegendModal(!showIconLegendModal)} data-testid="icon-legend-btn">
        <svg
          id="icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 32 32"
          fill={showIconLegendModal ? "white" : "#023E65"}
          cursor="pointer"
        >
          <title>legend</title>
          <rect x="16" y="22" width="14" height="2" />
          <rect x="4" y="20" width="6" height="6" rx="1" />
          <rect x="16" y="8" width="14" height="2" />
          <path d="M9.5,12h-5a.5.5,0,0,1-.4473-.7236l2.5-5.0224a.5206.5206,0,0,1,.8945,0l2.5,5.0225A.5.5,0,0,1,9.5,12Z" />
          <rect
            id="_Transparent_Rectangle_"
            data-name="<Transparent Rectangle>"
            fill="none"
            width="32"
            height="32"
          />
        </svg>
      </div>
      {showIconLegendModal && <IconLegendModal />}
    </div>
  )
}

export default IconLegend;